import React from 'react';

const SvgMindfulness = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 104 104"
}, props), /*#__PURE__*/React.createElement("g", {
  className: "tourlane-Careers-Mindfulness__nc-icon-wrapper"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "tourlane-Careers-Mindfulness__path-1",
  d: "M9.155 0S5.39.977 2.514 5.786C-.363 10.595.017 14.043.017 14.043H0h32.223s.38-3.448-2.497-8.257c-2.378-3.974-5.36-5.641-6.325-5.76L9.155 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "tourlane-Careers-Mindfulness__path-5",
  d: "M4.648 0c2.486-.006 4.538 1.935 4.667 4.36l.006.23.04 14.824c1.749-1.727 4.573-1.79 6.399-.182l.185.173 10.578 10.387a4.552 4.552 0 011.328 2.653l.03.291.007 1.308-.025 14.605-16.083-.007V44.67l-3.303-4.345-3.25-4.308-1.928-2.584-1.628-2.22-.914-1.283-.395-.578-.172-.265-.124-.204L0 4.614C-.007 2.083 2.085.007 4.648 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "tourlane-Careers-Mindfulness__path-7",
  d: "M4.648 0c2.486-.006 4.538 1.935 4.667 4.36l.006.23.04 14.824c1.749-1.727 4.573-1.79 6.399-.182l.185.173 10.578 10.387a4.552 4.552 0 011.328 2.653l.03.291.007 1.308-.025 14.605-16.083-.007V44.67l-3.303-4.345-3.25-4.308-1.928-2.584-1.628-2.22-.914-1.283-.395-.578-.172-.265-.124-.204L0 4.614C-.007 2.083 2.085.007 4.648 0z"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "tourlane-Careers-Mindfulness__path-3",
  cx: 13.275,
  cy: 13.685,
  rx: 13.275,
  ry: 13.685
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(34.92 39.437)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-Careers-Mindfulness__mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-Careers-Mindfulness__path-1"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#59DD7D",
  xlinkHref: "#tourlane-Careers-Mindfulness__path-1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "M11.762 5.942c.295 0 .534.239.534.534v.256a.534.534 0 01-.534.534l-.72-.001.002 2.777a.534.534 0 01-.534.534h-.185a.534.534 0 01-.534-.534V7.265h-.718a.534.534 0 01-.534-.533v-.256c0-.295.239-.534.534-.534h2.69z",
  mask: "url(#tourlane-Careers-Mindfulness__mask-2)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15.99,
  cy: 8.354,
  r: 1,
  fill: "#F5F5F5",
  mask: "url(#tourlane-Careers-Mindfulness__mask-2)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15.99,
  cy: 11.459,
  r: 1,
  fill: "#F5F5F5",
  mask: "url(#tourlane-Careers-Mindfulness__mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#50C871",
  d: "M13.52 1.751h5.2l-2.6 4.276-2.6-4.276z",
  mask: "url(#tourlane-Careers-Mindfulness__mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(37.765 15)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-Careers-Mindfulness__mask-4",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-Careers-Mindfulness__path-3"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#ECECEC",
  xlinkHref: "#tourlane-Careers-Mindfulness__path-3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M.107-3.447h26.378v11.84h-8.31L16.233 5.39l-1.81 3.003H.106z",
  mask: "url(#tourlane-Careers-Mindfulness__mask-4)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#8D8D8D",
  mask: "url(#tourlane-Careers-Mindfulness__mask-4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.812 19.592a.7.7 0 01.973.262.746.746 0 01-.254 1.003c-1.18.714-2.533 1.069-4.045 1.069-1.505 0-2.896-.352-4.162-1.056a.745.745 0 01-.29-.993.7.7 0 01.964-.297c1.056.586 2.216.88 3.488.88 1.267 0 2.37-.29 3.326-.868zM9.73 14.787c.23.222.59.21.805-.026a.6.6 0 00-.026-.83c-.778-.751-1.692-1.135-2.715-1.135-1.017 0-1.953.378-2.787 1.12a.6.6 0 00-.059.826.557.557 0 00.803.06c.632-.562 1.306-.834 2.043-.834.73.001 1.366.268 1.936.818zM21.11 14.787c.229.222.589.21.804-.026a.6.6 0 00-.026-.83c-.778-.751-1.692-1.135-2.715-1.135-1.018 0-1.953.378-2.787 1.12a.6.6 0 00-.06.827.557.557 0 00.803.06c.633-.562 1.307-.834 2.044-.834.73 0 1.367.267 1.937.818z"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(11 34.76)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-Careers-Mindfulness__mask-6",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-Careers-Mindfulness__path-5"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#ECECEC",
  xlinkHref: "#tourlane-Careers-Mindfulness__path-5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M9.592 17.41c.224-.18.562-.212.776.003.214.216.217.58-.003.777-2.136 1.911-2.206 5.6-.768 7.181l.16.166 6.738 6.617a.549.549 0 01-.693.847l-.076-.063-6.739-6.617c-2.035-2-1.965-6.852.605-8.91z",
  mask: "url(#tourlane-Careers-Mindfulness__mask-6)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 92.12 34.76)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-Careers-Mindfulness__mask-8",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-Careers-Mindfulness__path-7"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#ECECEC",
  xlinkHref: "#tourlane-Careers-Mindfulness__path-7"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M9.592 17.41c.224-.18.562-.212.776.003.214.216.217.58-.003.777-2.136 1.911-2.206 5.6-.768 7.181l.16.166 6.738 6.617a.549.549 0 01-.693.847l-.076-.063-6.739-6.617c-2.035-2-1.965-6.852.605-8.91z",
  mask: "url(#tourlane-Careers-Mindfulness__mask-8)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#50C871",
  d: "M22.32 89.77l16.708-.05a1 1 0 00.997-1.001l-.01-5.414a1 1 0 00-1.003-.998l-16.707.05a1 1 0 00-.997 1l.01 5.414a1 1 0 001.002.999zM80.799 89.77l-16.707-.05a1 1 0 01-.997-1.001l.01-5.414a1 1 0 011.002-.998l16.708.05a1 1 0 01.997 1l-.01 5.414a1 1 0 01-1.003.999z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#E0E0E0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M52.281 65.593l.046 9.83a1.015 1.015 0 01-1.015 1.02 1.023 1.023 0 01-1.023-1.02l-.034-9.83a1.009 1.009 0 011.01-1.012c.56 0 1.014.452 1.016 1.012zM57.081 63.778l.034 7.191a1.02 1.02 0 01-1.02 1.025 1.028 1.028 0 01-1.028-1.025l-.024-7.19a1.015 1.015 0 011.015-1.019c.563 0 1.02.455 1.023 1.018zM46.901 63.778l.034 7.198a1.013 1.013 0 01-1.013 1.018c-.563 0-1.02-.455-1.023-1.018l-.034-7.198a1.013 1.013 0 011.013-1.018c.563 0 1.02.455 1.023 1.018z"
})))));

export default SvgMindfulness;